import { Component, Input, OnInit } from '@angular/core';
import { fakeAsset } from '@features/contentful/helpers/assetHelpers';
import { CustomPage } from '@generated/graphql';

import { AssetImageConfiguration } from '@features/lazy-image/components/lazy-asset-lazy/lazy-asset-lazy.component';
import { TrustpilotBadgeComponent } from '@shared/trustpilot-badge/trustpilot-badge.component';

@Component({
    selector: 'app-home-reviews',
    templateUrl: './home-reviews.component.html',
    imports: [TrustpilotBadgeComponent],
})
export class HomeReviewsComponent implements OnInit {
    @Input() homePage: CustomPage;
    trustPilotImageConfiguration: AssetImageConfiguration;
    constructor() {}

    ngOnInit(): void {
        this.trustPilotImageConfiguration = {
            image: fakeAsset(
                '/assets/images/trustpilot.png',
                'See our reviews on Trustpilot'
            ),
            ratioWidth: 2.25,
            ratioHeight: 1,
            width: 216,
        };
    }
}
